import React from 'react';
import { Link } from 'react-router-dom';
import { Eye, Heart, BookOpen } from 'lucide-react';
import SaveButton from './SaveButton';

const SeriesCard = ({ series }) => {
  return (
    <Link
      to={`/series/${series.id}`}
      className="group block relative"
    >
      {/* Cover Image */}
      <div className="relative aspect-[2/3] bg-gray-800 rounded-lg overflow-hidden mb-3">
        {series.cover_url ? (
          <img
            src={series.cover_url}
            alt={series.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
          />
        ) : (
          <div className="w-full h-full bg-gradient-to-br from-orange-500 to-red-500 flex items-center justify-center">
            <BookOpen className="w-16 h-16 text-white opacity-50" />
          </div>
        )}
        
        {/* Hover Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="absolute bottom-0 left-0 right-0 p-4">
            <p className="text-white text-sm line-clamp-3">
              {series.description || 'No description available'}
            </p>
          </div>
        </div>

        {/* Status Badge */}
        {series.status && series.status !== 'ongoing' && (
          <div className="absolute top-2 right-2">
            <span className="bg-orange-500 text-white text-xs font-bold px-2 py-1 rounded">
              {series.status.toUpperCase()}
            </span>
          </div>
        )}
      </div>

      {/* Series Info */}
      <div className="space-y-1">
        <h3 className="font-bold text-white group-hover:text-orange-500 transition-colors line-clamp-2 text-sm">
          {series.title}
        </h3>
        
        {/* Stats + Save */}
        <div className="flex items-center justify-between text-xs text-gray-500">
          <div className="flex items-center space-x-3">
            <div className="flex items-center space-x-1">
              <Eye className="w-3 h-3" />
              <span>{series.metrics_cache?.views?.toLocaleString() || 0}</span>
            </div>
            <div className="flex items-center space-x-1">
              <Heart className="w-3 h-3" />
              <span>{series.metrics_cache?.subscribers?.toLocaleString() || 0}</span>
            </div>
            <div className="flex items-center space-x-1">
              <BookOpen className="w-3 h-3" />
              <span>{series.metrics_cache?.chapters || 0}</span>
            </div>
          </div>
          <div onClick={(e) => e.preventDefault()}>
            <SaveButton
              targetId={series.id}
              targetType="series"
              initialSaved={series._saved}
              saveCount={series.save_count || 0}
              size="sm"
            />
          </div>
        </div>

        {/* Genres */}
        {series.genres && series.genres.length > 0 && (
          <p className="text-xs text-gray-600 line-clamp-1">
            {series.genres.slice(0, 2).join(', ')}
          </p>
        )}
      </div>
    </Link>
  );
};

export default SeriesCard;
